module.exports = __webpack_public_path__ + "_assets/img/phone.1c0e7ac1.svg";